import { module } from "./core";
import { getDomain, replaceDomain } from "./help/url";
import { $get, $httpGet, $skxhr, $skxhrp, $upload } from "./services";
import { staticJson } from "./services/static";
import { goto } from "./core/goto";
import { saveChannelParams } from "./core/channel";

declare let $sk: any;

if (!$sk) {
  $sk = {};
}
saveChannelParams();

$sk.template = module;
$sk.staticJson = staticJson;
$sk.$skxhr = $skxhr;
$sk.$skxhrp = $skxhrp;
$sk.$upload = $upload;
$sk.$xhrget = $httpGet;
$sk.$xhrgetp = $get;

$sk.$help = {
  replaceDomain,
  getDomain,
};

$sk.goto = (s: string, b = false) => {
  const m = goto.init(s, b);
  return b ? m : "javascript:;";
};
$sk.replaceDomain = replaceDomain;
